import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { Plus, History } from "lucide-react";
import { useDashboardContext } from "@/components/DashboardLayout";
import { useNavigate } from "react-router-dom";

export default function DashboardPage() {
  const { user } = useAuth();
  const { openNewAnalysis } = useDashboardContext();
  const navigate = useNavigate();

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-foreground font-display">Dashboard</h1>
          <p className="text-muted-foreground text-sm mt-1">Welcome back, {user?.email}</p>
        </div>
        <Button onClick={openNewAnalysis} className="gap-2">
          <Plus className="h-4 w-4" />
          New Analysis
        </Button>
      </div>

      <div className="grid gap-4 sm:grid-cols-2">
        <button
          onClick={openNewAnalysis}
          className="rounded-lg border border-border bg-card p-6 text-left hover:bg-muted/50 transition-colors"
        >
          <Plus className="h-5 w-5 text-primary mb-2" />
          <p className="text-sm font-medium text-foreground">Run a new analysis</p>
          <p className="text-xs text-muted-foreground mt-1">Enter a URL to get a full SEO report.</p>
        </button>
        <button
          onClick={() => navigate("/analyses")}
          className="rounded-lg border border-border bg-card p-6 text-left hover:bg-muted/50 transition-colors"
        >
          <History className="h-5 w-5 text-primary mb-2" />
          <p className="text-sm font-medium text-foreground">Previous analyses</p>
          <p className="text-xs text-muted-foreground mt-1">Revisit your past SEO reports.</p>
        </button>
      </div>
    </div>
  );
}
